"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promoVideoComponent = exports.SpotComponent = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var webexUI_1 = require("webexUI");
var KeepTheRhythm_1 = require("Views/Partials/Components/KeepTheRhythm");
var SpotComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SpotComponent, _super);
    function SpotComponent() {
        var _this = _super.call(this) || this;
        _this.selector = '.spot-singlelink, .spot-multilink, .spot-two_plus_one';
        _this.moreInfoControlsSelector = '.expandable-text-controls';
        _this.readMoreBtnClass = 'expandable-text-read-more';
        _this.readLessBtnClass = 'expandable-text-read-less';
        _this.expandedDescriptionClass = 'expandable-description--expanded';
        _this.moreInfoControlsVisibleClass = 'expandable-text-controls--visible';
        _this.visibleLinesCountOnMobile = 3;
        _this.visibleAreaMaxHeight = KeepTheRhythm_1.KeepTheRhythmComponent.baseline * _this.visibleLinesCountOnMobile;
        _this.mobileViewInitialized = false;
        _this.initMobileView = function () {
            _this.handleMobileDescription();
            _this.mobileViewInitialized = true;
        };
        _this.dismissMobileView = function () {
            _this.el.forEach(function (el) {
                var moreInfoControls = el.querySelectorAll(_this.moreInfoControlsSelector);
                _this.hideMoreInfoControls(moreInfoControls);
            });
        };
        _this.handleMobileDescription = function () {
            _this.el.forEach(function (el) {
                var description = el.querySelector('.spot-content__description');
                var descriptionInner = description === null || description === void 0 ? void 0 : description.querySelector('.spot-content__description-inner');
                var moreInfoControls = el.querySelectorAll(_this.moreInfoControlsSelector);
                if (descriptionInner && $(descriptionInner).innerHeight() <= _this.visibleAreaMaxHeight) {
                    _this.hideMoreInfoControls(moreInfoControls);
                }
                else {
                    _this.showMoreInfoControls(moreInfoControls);
                }
                if (!_this.mobileViewInitialized) {
                    _this.attachMoreInfoButtonsHandlers(description, moreInfoControls);
                }
            });
        };
        document.querySelectorAll('.spot-cascade').forEach(function (el) {
            _this.checkExternalLinks(el.querySelectorAll('a'));
        });
        return _this;
    }
    SpotComponent.prototype.OnInit = function () {
        var _this = this;
        this.el.forEach(function (el) {
            var spotLink = el.querySelector('.spot-link');
            if (spotLink) {
                var externalLink = new app_1.ExternalLink();
                if (externalLink.isExternal(spotLink)) {
                    externalLink.insertIcon(el.querySelector('.spot-content__title'));
                }
            }
            _this.checkExternalLinks(el.querySelector('.spot-content-container').querySelectorAll('a'));
        });
        if ((0, webexUI_1.detectBreakpoint)(webexUI_1.Breakpoint.UpToTablet)) {
            this.initMobileView();
        }
    };
    SpotComponent.prototype.OnWindowResizeThrottle = function () {
        if ((0, webexUI_1.detectBreakpoint)(webexUI_1.Breakpoint.UpToTablet)) {
            if (!this.mobileViewInitialized) {
                this.initMobileView();
            }
            else {
                this.handleMobileDescription();
            }
        }
        else if (this.mobileViewInitialized) {
            this.dismissMobileView();
        }
    };
    SpotComponent.prototype.attachMoreInfoButtonsHandlers = function (description, moreInfoControls) {
        var _this = this;
        moreInfoControls.forEach(function (moreInfoControl) {
            moreInfoControl.addEventListener('click', function (e) {
                var targetEl = e.target;
                if (targetEl.classList.contains(_this.readMoreBtnClass)) {
                    _this.expandMobileDescription(description);
                }
                else if (targetEl.classList.contains(_this.readLessBtnClass)) {
                    _this.collapseMobileDescription(description);
                }
                return false;
            });
        });
    };
    SpotComponent.prototype.showMoreInfoControls = function (moreInfoControls) {
        var _this = this;
        moreInfoControls.forEach(function (moreInfoControl) {
            return moreInfoControl.classList.add(_this.moreInfoControlsVisibleClass);
        });
    };
    SpotComponent.prototype.hideMoreInfoControls = function (moreInfoControls) {
        var _this = this;
        moreInfoControls.forEach(function (moreInfoControl) {
            return moreInfoControl.classList.remove(_this.moreInfoControlsVisibleClass);
        });
    };
    SpotComponent.prototype.expandMobileDescription = function (description) {
        description.classList.add(this.expandedDescriptionClass);
    };
    SpotComponent.prototype.collapseMobileDescription = function (description) {
        description.classList.remove(this.expandedDescriptionClass);
    };
    SpotComponent.prototype.checkExternalLinks = function (links) {
        var externalLink = new app_1.ExternalLink(links);
        externalLink.checkLinks();
    };
    SpotComponent.prototype.addExternalLinkIcon = function (link, isSpotMultiLink) {
        var externalLink = new app_1.ExternalLink();
        if (isSpotMultiLink) {
            if (externalLink.isExternal(link)) {
                externalLink.insertIcon(link);
            }
        }
        else {
            if (externalLink.isExternal(link)) {
                var spotLinkTitle = link.parentNode.querySelector('.spot-content__title');
                if (spotLinkTitle && externalLink.isExternal(link)) {
                    externalLink.insertIcon(link);
                }
            }
        }
    };
    return SpotComponent;
}(app_1.Component));
exports.SpotComponent = SpotComponent;
exports.promoVideoComponent = new SpotComponent();
